import { dropEmptyKeys } from "../../utils/helper"

class PromoteOrDemoteMembersRequest {

    constructor({
        sort, 
        page,
        search,
        tagIds,
        perPage,
        hasApp,
        channelIds,
        isFollower,
        communityId,
        actionIsPublicFollower,
    }) {
        this.page = page
        this.sort = sort
        this.tagIds = tagIds
        this.hasApp = hasApp
        this.search = search
        this.perPage = perPage
        this.isFollower = isFollower
        this.channelIds = channelIds
        this.communityId = communityId
        this.actionIsPublicFollower = actionIsPublicFollower
    }


    getPayload = () => {
        
        const payload = {
            "page": this.page,
            "sort": this.sort,
            "search": this.search,
            "per_page": this.perPage.value,
            "community_id": this.communityId,
            "tag_ids": [].concat(this.tagIds).join(","),
            "channel_ids": [].concat(this.channelIds).join(","),
            "action_is_public_follower": this.actionIsPublicFollower,
        }

        if (this.hasApp !== -1) {
            payload["has_app"] = this.hasApp
        }
        
        if (this.isFollower !== -1) {
            payload["is_public_follower"] = this.isFollower
        }

        return dropEmptyKeys(payload)
    }
    
}

export default PromoteOrDemoteMembersRequest